import React from "react";

const defaultValue = {
  isMenuCollapsed: false,
  setIsMenuCollapsed: () => {},

  menuFunctions : null,
  setMenuFunctionsHandler : () => {},
};

export const MenuContext = React.createContext(defaultValue);
